import React, { useContext } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

import { SCREEN_SIZE_CATEGORIES } from 'constants';
import { BookmarkButton, ReaderSlider, TTSButton } from './components';
import { ViewportValuesContext } from 'contexts';

const useStyles = makeStyles((theme) => ({
  scrubbar: (props) => ({
    fontFamily: theme.typography.fontFamily,
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gap: '12px',
    justifyContent: 'space-between',
    width: '100%',
    height: theme.spacing(7.25),
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      borderTop: 'solid 1px #e5e5e5',
      boxShadow: 'none !important',
    },
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing(6.25),
    },
    backgroundColor: '#fff',
    zIndex: 1,
    boxShadow: props.ttsActive
      ? 'none'
      : '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
  }),
  scrubbar__ttsAndBookmark: {
    display: 'flex',
    marginRight: '12px',
  },
}));

const ScrubBar = (props) => {
  const {
    isMobileScrollingView = false,
    onChooseNewLocation = () => {},
    onTTSClick = () => {},
    ttsActive,
    ttsButtonRef,
    ...otherProps
  } = props;

  const classes = useStyles(props);

  const { viewport } = useContext(ViewportValuesContext);
  const isMobile = viewport.widthCategory <= SCREEN_SIZE_CATEGORIES.PHONE;
  let elevation = isMobile ? 8 : 1;

  return (
    <Box className={classes.scrubbar} elevation={elevation} {...otherProps}>
      <ReaderSlider
        isMobile={isMobile}
        isMobileScrollingView={isMobileScrollingView}
        onChooseNewLocation={onChooseNewLocation}
      />
      <div className={classes.scrubbar__ttsAndBookmark}>
        <TTSButton
          onTTSClick={onTTSClick}
          ttsActive={ttsActive}
          ttsButtonRef={ttsButtonRef}
        />
        <BookmarkButton />
      </div>
    </Box>
  );
};

ScrubBar.propTypes = {
  isMobileScrollingView: PropTypes.bool,
  onChooseNewLocation: PropTypes.func,
  onTTSClick: PropTypes.func,
  ttsActive: PropTypes.bool,
  ttsButtonRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default ScrubBar;
